module.exports = __webpack_public_path__ + "381ef8512b8ac6c80fab1a08b283f8be.jpg";